import React, { useState, useEffect } from "react";

import { ListMenu } from "components/items";
import ic_left from "image/ic_left.svg";
const LINKSHOP = "https://smartstore.naver.com/donggubat";
const menuArr = [
	{
		id: "menu-about",
		gnb: { name: "about us", link: null },
		lnb: [
			{ name: "동구밭", link: "/about" },
			{ name: "미디어", link: "/about/media" },
		],
	},
	{
		id: "menu-services",
		gnb: { name: "service", link: "/service" },
		lnb: null,
	},
	{
		id: "menu-portfolio",
		gnb: { name: "portfolio", link: "/portfolio" },
		lnb: null,
	},
	{
		id: "menu-recruit",
		gnb: { name: "recruit", href: "https://mysterious-cloche-461.notion.site/7d7503ab9c0947aab41c805ac21d970f" },
		lnb: null,
	},
	{
		id: "menu-customer",
		gnb: { name: "customer center", link: "/customer" },
		lnb: null,
	},
];

const Menu = (props) => {
	const [isLnbClicked, setLnb] = useState(false);
	const [nowLnb, setNowLnb] = useState();

	const menuToggle = () => {
		setLnb(!isLnbClicked);
		setNowLnb(null);
	};

	useEffect(() => {
		setLnb(false);
		setNowLnb(null);
	}, [props.isMenuClicked]);

	const lnbClickHandler = (e) => {
		menuToggle();
		setNowLnb(e.target.id);
	};

	const drawMenu = () => {
		return menuArr.map((el) => {
			return <ListMenu key={el.id} items={el} lnbClickHandler={lnbClickHandler} active={el.id === nowLnb ? true : false} setMenu={props.setMenu} isMenuClicked={props.isMenuClicked} />;
		});
	};

	return (
		<section className={props.isMenuClicked ? "wrap-menu menu-show" : "wrap-menu"}>
			<div className="con">
				<div className={isLnbClicked ? "btn-menu-back backBtn-show" : "btn-menu-back"} onClick={menuToggle}>
					<img src={ic_left} alt="left" />
				</div>

				<ul className={isLnbClicked ? " header-gnb-mobile font-gnb show-lnb" : "header-gnb-mobile font-gnb"}>{drawMenu()}</ul>

				<div className="btn-shop-mobile font-gnb">
					<a href={LINKSHOP}>shop</a>
				</div>
			</div>
		</section>
	);
};

export default Menu;
